import nasreen from "../assets/images/nasreen.jpeg";
import aadhil from "../assets/images/aadhil.jpeg";
import sara from "../assets/images/sara.jpeg";
import anjali from "../assets/images/anjali.jpeg";
import anwar from "../assets/images/anwar.jpg";
import hemanthsagar from "../assets/images/hemanthsagar.jpeg";
import faiza from "../assets/images/faiza.jpeg";

export const contactsData = [
  {
    id: 1,
    name: "Nasreen K Basheer",
    designation: "Chairperson",
    image: nasreen,
    phone: "9605204433",
    email: "nasreenkbasheer.mec@gmail.com",
    linkedIn: "https://www.linkedin.com/in/nasreen-k-basheer-6795331a5/",
  },
  {
    id: 2,
    name: "Hemanth Sagar J C",
    designation: "General Secretary",
    image: hemanthsagar,
    phone: "7012910210",
    email: "hemanthsagar.mec@gmail.com",
    linkedIn: "https://www.linkedin.com/in/hemanth-sagar-j-c-292a98195",
  },
  {
    id: 3,
    name: "Anjali Rajendran",
    designation: "Marketing Manager",
    image: anjali,
    phone: "9497609957",
    email: "anjalirajendran.mec@gmail.com",
    linkedIn: "https://www.linkedin.com/in/anjali-rajendran28/",
  },
  {
    id: 4,
    name: "Sara Suzaan Suresh",
    designation: "Conference and Workshops Manager",
    image: sara,
    phone: "7994810209",
    email: "sarasuzaansuresh.mec@gmail.com",
    linkedIn: "https://www.linkedin.com/in/sara-suzaan-suresh-42b816190/",
  },
  {
    id: 5,
    name: "Sayyed Anwar",
    designation: "Conference and Workshops Manager (PC)",
    image: anwar,
    phone: "7306300358",
    email: "anwarsayyed80732@gmail.com",
    linkedIn: "https://www.linkedin.com/in/sayyed-anwar-89974017a/",
  },
  {
    id: 6,
    name: "Aadhil Farhan",
    designation: "Event Head",
    image: aadhil,
    phone: "9400814329",
    email: "aadhilfarhan.mec@gmail.com",
    linkedIn: "https://www.linkedin.com/in/aadhil-farhan/",
  },
  {
    id: 7,
    name: "Faiza S Rahman",
    designation: "Event Head",
    image: faiza,
    phone: "8547864728",
    email: "faizasrahman@gmail.com",
    linkedIn: "https://www.linkedin.com/in/faiza-s-rahman-8a5643203/",
  },
]